<template>
 
<div>
<div style="color:#38adff;background:url(image/bg4.jpg);background-position:center top;margin-top:50px">
  <div class="content" align="center">
    <br><h1>更具价值的 ERP 系统</h1>
    <p class="textBig" style="display:inline-block;*display:inline;*zoom:1;margin:0px;">100多个应用模块 &bull;  </p> &bull; <p class="textBig" style="display:inline-block;*display:inline;*zoom:1;margin:0px;">24小时移动访问 &bull; N多项创新设计</p>
    <br><br>
    <img class="contentImage" alt="ERP价格" src="/static/picture/valuable.png">
  </div>
</div>

<div class="contentContainer2">
  <div class="content textMiddle">
    <h2 class="highlight3" align="center">即刻租用，全员协同办公</h2><br>
    <div class="block2">
      <table cellspacing="0" cellpadding="0" border="0">
        <tr valign="top"><td><p class="box" style="margin-right:15px;padding:0px 10px;">1</p></td><td>
          <p>请选择 <input type="radio" name="priceMode" checked="" value="1" onclick="setTotal(1);">公有云 <input type="radio" name="priceMode" value="2" onclick="setTotal(2);">私有云  </p>
           
        </td></tr>
        <tr valign="top"><td><p   style="margin-right:15px;padding:0px 10px;"></p></td><td>
          <p>  </p>
           
        </td></tr>
       
      </table>
	  	<div style="margin-left:100px; margin-top: 50px">
		<el-button type="primary"  @click="toPay()"    > 查看详情</el-button>  </div>
		
	  
    </div> 
  </div>
</div> 

<div class="contentContainer">
 
  <div class="content">
 
    <table cellspacing="10" cellpadding="0" border="0"><tr valign="top"><td> </td><td>
      <h2>私有云部署模式</h2>
      <input type="checkbox" checked="" disabled=""> 在自己的服务器上，快速安装和部署<br>
      <input type="checkbox" checked="" disabled=""> 支持10000+用户使用和复杂的业务流程<br>
      <input type="checkbox" checked="" disabled=""> 定制实现个性化的业务流程、功能和集成<br>
      <input type="checkbox" checked="" disabled=""> 一次性购买永久使用 
    </td></tr></table> 
    <div class="block3">
   
      <div class="box">
        <div class="highlight3" align="center">￥<span style="font-size:48px;">6980</span>元/永久</div>
        <div class="textBig box2" align="center">【 ERP 标准版 】</div>
        <p style="padding:20px 0px 20px 20px;">
          <input type="checkbox" checked="" disabled=""> <b>我的桌面</b>：聚合式工作平台<br>
          <input type="checkbox" checked="" disabled=""> <b>我的事务</b>：全面流程化驱动<br>
          <input type="checkbox" checked="" disabled=""> <b>目标管理</b>：层层落实和追踪<br>
          &nbsp;&nbsp;&nbsp;&nbsp;<img src="/static/picture/flowChart.gif" border="0"> <span class="textGray">计划、任务、报告等3大流程</span><br>
          <input type="checkbox" checked="" disabled=""> <b>信息中心</b>：知识积累和分享<br>
          &nbsp;&nbsp;&nbsp;&nbsp;<img src="/static/picture/flowChart.gif" border="0"> <span class="textGray">新闻公告、文档管理等5大流程</span><br>
          <input type="checkbox" checked="" disabled=""> <b>行政管理</b>：办公和运营支撑<br>
          &nbsp;&nbsp;&nbsp;&nbsp;<img src="/static/picture/flowChart.gif" border="0"> <span class="textGray">会议室、资产、用品等18种流程</span><br>
          <input type="checkbox" checked="" disabled=""> <b>人力资源</b>：全面流程化管理<br>
          &nbsp;&nbsp;&nbsp;&nbsp;<img src="/static/picture/flowChart.gif" border="0"> <span class="textGray">招聘、考勤、考核等18种流程</span><br>
          <input type="checkbox" checked="" disabled=""> <b>财务中心</b>：精细化费用支出<br>
          &nbsp;&nbsp;&nbsp;&nbsp;<img src="/static/picture/flowChart.gif" border="0"> <span class="textGray">费用、票据、资金等8种流程</span><br>
          <input type="checkbox" checked="" disabled=""> <b>业务流程</b>：自主可视化设计 <img src="/static/picture/hot.gif" border="0"><br>
          <input type="checkbox" checked="" disabled=""> <b>系统管理</b>：组织架构和分权<br>
          <input type="checkbox" checked="" disabled=""> <b>设置中心</b>：个性化办公设置<br>
        <!--  <br><img src="/static/picture/hot.gif" border="0"> 免费升至 <a href="javascript:;" target="_blank">CollERP<sup>&reg;</sup>超级流程引擎</a>  -->
          <br><span class="textGray">—— 量身定制各种流程和报表</span>
        </p>
      </div>

    </div><div class="block3">

    

    </div><div class="block3">
    
      

    </div>
  </div>
</div>

 

<div class="contentContainer">
  <div class="content"> 
    <table cellspacing="10" cellpadding="0" border="0"><tr valign="top"><td> </td><td>
      <h2>公有云服务模式</h2>
      <input type="checkbox" checked="" disabled=""> 零 IT 硬件成本投入，零 IT 维护工作量<br>
      <input type="checkbox" checked="" disabled=""> 零安装部署，分期租用并独享云服务空间<br>
      <input type="checkbox" checked="" disabled=""> 支持用户的平滑扩容和业务流程的扩展<br>
      <input type="checkbox" checked="" disabled=""> 按使用时长分期付费，10用户3个月起售
    </td></tr></table>

    <div class="block3">

      <div class="box">
        <div class="highlight3" align="center">￥<span style="font-size:48px;">680</span>元/年</div>
        <div class="textBig box2" align="center">【  ERP 标准版 】</div>
        <p style="padding:20px 0px 20px 20px;">
          <input type="checkbox" checked="" disabled=""> <b>我的桌面</b>：聚合式工作平台<br>
          <input type="checkbox" checked="" disabled=""> <b>我的事务</b>：全面流程化驱动<br>
          <input type="checkbox" checked="" disabled=""> <b>目标管理</b>：层层落实和追踪<br>
          &nbsp;&nbsp;&nbsp;&nbsp;<img src="/static/picture/flowChart.gif" border="0"> <span class="textGray">计划、任务、报告等3大流程</span><br>
          <input type="checkbox" checked="" disabled=""> <b>信息中心</b>：知识积累和分享<br>
          &nbsp;&nbsp;&nbsp;&nbsp;<img src="/static/picture/flowChart.gif" border="0"> <span class="textGray">新闻公告、文档管理等5大流程</span><br>
          <input type="checkbox" checked="" disabled=""> <b>行政管理</b>：办公和运营支撑<br>
          &nbsp;&nbsp;&nbsp;&nbsp;<img src="/static/picture/flowChart.gif" border="0"> <span class="textGray">会议室、资产、用品等18种流程</span><br>
          <input type="checkbox" checked="" disabled=""> <b>人力资源</b>：全面流程化管理<br>
          &nbsp;&nbsp;&nbsp;&nbsp;<img src="/static/picture/flowChart.gif" border="0"> <span class="textGray">招聘、考勤、考核等18种流程</span><br>
          <input type="checkbox" checked="" disabled=""> <b>财务中心</b>：精细化费用支出<br>
          &nbsp;&nbsp;&nbsp;&nbsp;<img src="/static/picture/flowChart.gif" border="0"> <span class="textGray">费用、票据、资金等8种流程</span><br>
          <input type="checkbox" checked="" disabled=""> <b>业务流程</b>：自主可视化设计<br>
          <input type="checkbox" checked="" disabled=""> <b>系统管理</b>：组织架构和分权<br>
          <input type="checkbox" checked="" disabled=""> <b>设置中心</b>：个性化办公设置<br>
        </p>
      </div>
       </div>
    </div>
 
</div>



<div class="contentContainer">
  <div class="content">
    <h2 class="highlight3" align="center">常见问题和解答</h2><br>
    <div class="block2">
      <table cellspacing="10" cellpadding="0" border="0">
        <tr valign="top"><td><div class="box" style="padding:0px 5px;">问</div></td><td>智造云ERP能够免费使用吗？为什么不是免费的？</td></tr>
        <tr valign="top"><td><div class="box" style="padding:0px 5px;">答</div></td><td>免费只是营销噱头，不是正常的商业模式，因此免费一般伴随着潜藏的收费项目、广告干扰、系统故障和数据风险。作为专业的ERP领导厂商，我们明码标价，提供稳定、持续而高质量的服务，保证双方的长远发展和互利共赢。<br><br></td></tr>
        <tr valign="top"><td><div class="box" style="padding:0px 5px;">问</div></td><td>相较于传统的ERP软件，智造云ERP系统价格如何？</td></tr>
        <tr valign="top"><td><div class="box" style="padding:0px 5px;">答</div></td><td>智造云ERP系统是历时十年开发的精品，提供了全面的功能和流程，相较于传统的、一般在几万到几十万的ERP系统价格，现在的智造云ERP公有云服务模式是价格特别优惠的。<br><br></td></tr>
        <tr valign="top"><td><div class="box" style="padding:0px 5px;">问</div></td><td>智造云ERP系统能够提供客户管理和项目管理吗？</td></tr>
        <tr valign="top"><td><div class="box" style="padding:0px 5px;">答</div></td><td>企业级的客户管理、项目管理或者进销存管理等，需要众多模块组合、细化用户分权、实施流程驱动。</td></tr>
      </table>
    </div><div class="block2">
      <table cellspacing="10" cellpadding="0" border="0">
        <tr valign="top"><td><div class="box" style="padding:0px 5px;">问</div></td><td>如果有特殊的业务流程，能够帮助定制吗？</td></tr>
        <tr valign="top"><td><div class="box" style="padding:0px 5px;">答</div></td><td>流程定制是我们的强项，我们帮助不同行业的不同客户，定制过上千种不同的业务流程，涉及项目、合同、销售、库存、采购、制造等等。请您先提出特殊的业务流程需求，发给我们进行评估并收费开发。<br><br></td></tr>
        <tr valign="top"><td><div class="box" style="padding:0px 5px;">问</div></td><td>大型复杂的业务系统，能够承接和开发吗？</td></tr>
        <tr valign="top"><td><div class="box" style="padding:0px 5px;">答</div></td><td>我公司具备核心技术平台 Delphi Datasnap，能够承接开发大型复杂的业务系统 。如有需要，可以当面洽谈和深入交流。<br><br></td></tr>
        <tr valign="top"><td><div class="box" style="padding:0px 5px;">问</div></td><td>智造云ERP系统购买后能开发票吗？如何开票？</td></tr>
        <tr valign="top"><td><div class="box" style="padding:0px 5px;">答</div></td><td>当然可以。请登录后进入账户设置，点击我的订单，然后填写公司全称、 纳税人识别号、开户行及账号、地址和电话、开票金额，我们将在3个工作日内开出并邮寄。</td></tr>
      </table>
    </div>
  </div>
</div>

</div>
</template>
  

<script>
 
export default {
 
        data () {
            return {
	    	is_loading: false,
		    userInfo: {},
			customShow : true,
			erpShow: false,
			amount: 0, 
			sk_id: 0,
			sk_name: '', 
			pay_mode: 'ali',
			} 
        },
        methods: { 
		  created(){
		   
		  },
		  toPay(){
			  let newUrl = this.$router.resolve({
                     name: "payment"
                     });
              window.open(newUrl.href, "_blank");	
		  },
		  

		},
		
		}
</script>



 


// WEBPACK FOOTER //
// src/components/price.vue